<template>
    <multiselect :options="valueOptions"
                 :customLabel="(v) => label(v)"
                 :show-labels="false"
                 :allowEmpty="false"
                 :placeholder="placeholder"
                 :value="value"
                 @input="$emit('input', $event)"
                 :searchable="searchable">
        <template slot="noResult">
            Keine Ergebnisse gefunden.
        </template>
        <template slot="beforeList">
            <slot name="beforeList"></slot>
        </template>
    </multiselect>
</template>

<script>
    import Multiselect from 'vue-multiselect'
    import _flatMap from 'lodash/flatMap'
    import _find from 'lodash/find'

    export default {
        components: {
            'multiselect': Multiselect
        },
        props: {
            options: Array,
            placeholder: {
                type: String,
                required: false,
                default: ''
            },
            value: String,
            searchable: {
                type: Boolean,
                required: false,
                default: true
            }
        },

        data() {
            return {
                gender: ''
            }
        },

        computed: {
            valueOptions() {
                return _flatMap(this.options, (o) => {
                    return o.value;
                })
            }
        },

        methods: {
            label(value) {
                let object = _find(this.options, (o) => {
                    return o.value === value;
                });

                return object ? object.label : '';
            }
        }
    }
</script>